import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
import { FiMoreVertical } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import { useGetSellerMessagesQuery } from "../redux/apislice"; 

const ChatInbox = ({ onSelectUser, selectedUser }) => {
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  // const navigate = useNavigate();

  const { data: chats = [], isLoading, isError } = useGetSellerMessagesQuery();

  const handleDropdownToggle = (chatId) => {
    setDropdownOpenId(dropdownOpenId === chatId ? null : chatId);
  };

  const handleMuteChat = (chatId) => {
    alert(`Mute chat with user ID: ${chatId}`);
    setDropdownOpenId(null);
  };

  const handleMarkAsRead = (chatId) => {
    alert(`Mark chat with user ID: ${chatId} as read`);
    setDropdownOpenId(null);
  };

  const filteredChats = chats.filter((chat) =>
    chat.username.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-4 space-y-3 relative w-full">
      <div className="flex items-center gap-2 mb-4">
        <h2 className="text-xl font-semibold">Chats</h2>
      </div>

      <input
        type="text"
        placeholder="Search chats..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      {isLoading && (
        <div className="text-center text-gray-500 py-8">Loading chats...</div>
      )}
      {isError && (
        <div className="text-center text-red-500 py-8">Failed to load chats.</div>
      )}

      <AnimatePresence>
        {!isLoading && !isError && filteredChats.length === 0 ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="text-center text-gray-500 py-8"
          >
            No chats found.
          </motion.div>
        ) : (
          filteredChats.map((chat) => (
            <motion.div
              key={chat.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              className={`relative flex items-center justify-between p-3 rounded-xl cursor-pointer ${
                selectedUser === chat.id
                  ? "bg-blue-100"
                  : "bg-white hover:bg-gray-100"
              } shadow transition`}
            >
              <div
                className="flex items-center gap-3"
                onClick={() => onSelectUser(chat.id)}
              >
                <img
                  src={
                    chat.image ||
                    "https://ui-avatars.com/api/?name=" +
                      encodeURIComponent(chat.username) +
                      "&background=random"
                  }
                  alt={chat.username}
                  className="w-10 h-10 rounded-full object-cover"
                />

                <div>
                  <p className="font-medium text-gray-800">{chat.username}</p>
                  <p className="text-sm text-gray-500">
                    {chat.lastMessage || ""}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                {chat.unreadCount > 0 && (
                  <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                    {chat.unreadCount}
                  </span>
                )}

                <button
                  onClick={() => handleDropdownToggle(chat.id)}
                  className="text-gray-500 hover:text-black focus:outline-none"
                >
                  <FiMoreVertical />
                </button>

                {dropdownOpenId === chat.id && (
                  <div className="absolute right-4 top-14 bg-white border shadow rounded-md z-50 w-40">
                    <ul className="text-sm text-gray-700">
                      <li
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleMuteChat(chat.id)}
                      >
                        🔇 Mute Chat
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleMarkAsRead(chat.id)}
                      >
                        ✅ Mark as Read
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </motion.div>
          ))
        )}
      </AnimatePresence>
    </div>
  );
};

export default ChatInbox;
